/* ZSportsTech — section-bars.js
   Scoped to #sc-brtime (Bat Repair · 07 timelines).
   Animates each gold fill 0 → data-fill% on enter-view.
   Reduced-motion / no-JS: the inline width keeps bars shown filled.
   Maps to → assets/section-bars.js in Shopify theme.
   ─────────────────────────────────────────────────── */
(function () {
  'use strict';

  var root = document.getElementById('sc-brtime');
  if (!root) return;

  var fills = Array.prototype.slice.call(root.querySelectorAll('.timeline-bar__fill'));
  if (!fills.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return; /* leave inline widths (already filled) */

  /* collapse to 0 before animating */
  fills.forEach(function (f) { f.style.width = '0%'; });

  function run() {
    fills.forEach(function (f, i) {
      var pct = parseFloat(f.getAttribute('data-fill') || '0');
      f.style.transitionDelay = (i * 80) + 'ms';
      f.style.width = pct + '%';
    });
  }

  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(); obs.disconnect(); }
      });
    }, { threshold: 0.25 });
    obs.observe(root);
  } else {
    run();
  }
}());
